import { configureStore, } from '@reduxjs/toolkit'
import activeTabReducer  from './reducers/activeTabSlice.js'
import wrappingReducer  from './reducers/pixiControlsSlice.js'
import canvasReducer from './reducers/pixiCanvasSlice.js';
import fabricControlsReducer from './reducers/fabriccontrolsSlice.js'
import fabricCanvasReducer  from  './reducers/fabricCanvasSlice.js';
import svgDetailsReducer  from  './reducers/svgSlice.jsx';
import colorsReducer  from  './reducers/colorSlice.js';
import mockupCategoriesReducer  from './reducers/mockupCategorySlice.js';
import pixiObjectPropertiesReducer  from  './reducers/pixiObjectPropertiesSlice.js';
import fontsReducer from './reducers/fontsSlice.js'
import elementsReducer from './reducers/elementsSlice.js'
import popupReducer from "./reducers/popUpSlice.js"
import uploadsReducer from './reducers/uploadSlice.js'
import waitReducer from './reducers/waitTextureSlice.js'
import wrapReducer from './reducers/wrapChangedSlice.js'
import uploadfontsReducer from './reducers/uploadFontsSlice.js'

export const store = configureStore({
  reducer: {
    activeTab: activeTabReducer,
    canvas: canvasReducer,
    canvasesstate: fabricControlsReducer,
    // fabricControls: fabricControlsReducer,
    fabricCanvas: fabricCanvasReducer,
    wrapping: wrappingReducer,
    svgDetails: svgDetailsReducer,
    pixiObjectProperties:pixiObjectPropertiesReducer,
    colors:colorsReducer,
    mockupCategories:mockupCategoriesReducer,
    fonts: fontsReducer,
    elements: elementsReducer, 
    popup: popupReducer,
    uploads:uploadsReducer,
      wait:waitReducer,
      wrap:wrapReducer,
      uploadfonts:uploadfontsReducer,
  },
})